// Curated high-value cards for the landing-page "How It Works" emblem marquee.
// UUIDs are Scryfall IDs (the last path segment of each trademagic.gg/cards/<uuid>
// URL Eric supplied). Image URLs are built at render time via
// AssetUrls.cards.getCardImage(id, 'small'); we deliberately store identifiers,
// not URLs, so the strip survives any CDN URL-pattern change.
// Count-agnostic: consumers render whatever this array contains.
export const MARQUEE_CARD_SCRYFALL_IDS: readonly string[] = [
  '1982f910-a9bd-4e94-a187-84381b22aacc', // The Soul Stone (Marvel's Spider-Man)
  'e20da6b5-1057-4a28-9e85-07de714e262f', // Wan Shi Tong, Librarian (Avatar: The Last Airbender)
  'fadd5e4b-9833-4564-a7d2-3ac1364f40d5', // Mountain (Asia Pacific Land Program)
  '49c85e36-de89-4fc0-8058-1eb5bf319c2d', // Silver Shroud Costume (Secret Lair Drop)
  '1d7dba1c-a702-43c0-8fca-e47bbad4a00f', // Plains (Unhinged)
  'd9228c15-06d1-4701-8619-1ad08d63275a', // Yuna, Hope of Spira (Final Fantasy)
  'aff6f306-4e54-4535-aa35-f7ef058fec49', // Island (European Land Program)
  'cef789e8-e4cc-4f61-bc15-debc2487777f', // Parallax Wave (Nemesis)
  '356547d1-f97e-4ef6-ab32-43e4673393ff', // Forest (European Land Program)
  'ce860ed4-a5bd-4347-9eab-dd716ea84db1', // Bloodthirsty Conqueror (Foundations)
  'f19a6f20-8ca1-4a8b-8488-bcb5d86868dc', // Marsh Flats (Modern Horizons 2)
  '1ce688fa-1fdb-4acd-b9b0-bf7325a6b8e0', // Choco, Seeker of Paradise (Final Fantasy)
  '209c591a-4ab2-4e89-9523-a7b766cf4e51', // Ouroboroid (Edge of Eternities)
  '09dd9023-f7ee-4e99-8821-7059deb83730', // Adarkar Wastes (Ice Age)
  '405df7c7-0e37-499e-9826-6bf9f5db7a40', // Nuka-Cola Vending Machine (Fallout)
  '1df66b60-9107-44d8-a013-24732b226c16', // The Great Henge (Throne of Eldraine Promos)
  'af92ec23-a252-4ae2-98d7-0dce19d18e35', // Swamp (Phyrexia: All Will Be One)
  'e419cd0b-2449-4cc5-9ead-b9e45e271700', // Phlage, Titan of Fire's Fury (Modern Horizons 3)
  '15ce92a3-0d51-4c8e-bbce-d225021b4c35', // Cloud, Ex-SOLDIER (Final Fantasy Commander)
  'c5cd0d88-53b5-4560-bce0-910b3b7be946', // Misty Rainforest (Modern Masters 2017)
];
